const dummy_t = (translationKey) => translationKey;

export default [
  {
    externalPath: {
      'en-US': 'https://healthyplanbyann.com/',
      'pl-PL': 'https://hpba.pl/',
    },
    translationKey: dummy_t('menu.blog'),
  },
  {
    path: '/knowledge',
    translationKey: dummy_t('menu.knowledge'),
  },
  {
    externalPath: {
      'en-US': 'https://dtbaen.zendesk.com/hc/en-us',
      'pl-PL': 'https://faq.dieta.hpba.pl/hc/pl',
    },
    translationKey: dummy_t('footer.contact'),
  },
];
